import { createContext } from 'react';
import { type AnyMongoAbility, createMongoAbility } from '@casl/ability';

export const AbilityContext = createContext<AnyMongoAbility>(createMongoAbility());
